(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a19"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Swiper === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/swiper@8/swiper-bundle.min.js';
    script.onload = initSwiper;
    document.head.appendChild(script);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/swiper@8/swiper-bundle.min.css';
    document.head.appendChild(link);
  } else {
    initSwiper();
  }

  function initSwiper() {
    const sections = document.querySelectorAll('.pre-magflow-perspective-section');
    
    sections.forEach(function(section) {
      if (section.dataset.swiperInitialized) return;
      
      const swiperEl = section.querySelector('.pre-magflow-perspectiveAll-swiper');
      const prevBtn = section.querySelector('.swiper-button-prev');
      const nextBtn = section.querySelector('.swiper-button-next');
      const nowIndexEl = section.querySelector('.magflow-perspective-swiper-nowindex');
      const slides = section.querySelectorAll('.swiper-slide');
      
      if (!swiperEl || !prevBtn || !nextBtn || slides.length === 0) return;
      
      section.dataset.swiperInitialized = 'true';

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,
        loopedSlides: slides.length,
        allowTouchMove: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          appendButtonsTo: false,
          hideOnClick: false
        },
        speed: 300,
        effect: 'slide',
        on: {
          slideChange: function() {
            if (nowIndexEl) {
              const currentIdx = this.realIndex + 1;
              nowIndexEl.textContent = currentIdx;
            }
          },
          init: function() {
            this.updateSize();
            this.updateSlides();
            prevBtn.style.position = 'static';
            nextBtn.style.position = 'static';
          }
        }
      });

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.slidePrev();
      });
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.slideNext();
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a20"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', function() {
  let swiper;
  const highlightsSection = document.getElementById('magflow-highlights-section');
  const slideCount = highlightsSection ? highlightsSection.querySelectorAll('.swiper-slide').length : 0;
  let currentSlideIndex = 0;
  let isScrollTriggered = false;

  if (typeof Swiper !== 'undefined' && slideCount > 0) {
    swiper = new Swiper(highlightsSection.querySelector('.magflow-highlights-swiper-main'), {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: true,
      speed: 500,
      autoplay: false,
      pagination: {
        el: highlightsSection.querySelector('.magflow-highlights-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class="${className} magflow-highlights-pagination-bullet"></div>`;
        },
      },
      on: {
        slideChange: function() {
          currentSlideIndex = this.activeIndex;
        }
      }
    });
  }

  if (highlightsSection) {
    highlightsSection.querySelectorAll('.magflow-highlights-contdiv-title').forEach(title => {
      title.addEventListener('click', function(e) {
        e.stopPropagation();
        const blockId = this.getAttribute('data-block');
        const targetIndex = this.getAttribute('data-index');
        const parentContDiv = this.closest('.magflow-highlights-contdiv');
        const currentSlide = this.closest('.swiper-slide');
        
        currentSlide.querySelectorAll(`.magflow-highlights-contdiv[data-block="${blockId}"]`).forEach(item => {
          item.classList.remove('active');
        });
        parentContDiv.classList.add('active');

        const targetImg = currentSlide.querySelector(`.magflow-highlights-item-img-${targetIndex}[data-block="${blockId}"]`);
        currentSlide.querySelectorAll(`.magflow-highlights-item-img[data-block="${blockId}"]`).forEach(img => {
          img.classList.remove('active');
        });
        if(targetImg) {
          targetImg.classList.add('active');
        }
      });
    });
  }

  function handleScrollTrigger() {
    if (!swiper || slideCount <= 1 || !highlightsSection) return;
    
    const rect = highlightsSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const triggerThreshold = rect.bottom + scrollY - windowHeight - 200;
    
    if (scrollY > triggerThreshold && !isScrollTriggered) {
      isScrollTriggered = true;
      
      if (currentSlideIndex < slideCount - 1) {
        swiper.slideTo(currentSlideIndex + 1, 500);
        
        setTimeout(() => {
          isScrollTriggered = false;
        }, 1000);
      }
    }
  }

  let debounceTimer;
  window.addEventListener('scroll', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleScrollTrigger();
    }, 150);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a21"] && !Shopify.designMode) return;
  try {
    
// 仅保留海报点击跳转功能
window.addEventListener('load', function() {
  const recommendedSection = document.getElementById('magflow-recommended-by-section');
  if (!recommendedSection) return;

  recommendedSection.querySelectorAll('.magflow-recommended-video-poster').forEach(poster => {
    poster.addEventListener('click', function() {
      const videoUrl = this.getAttribute('data-video-url');
      if (videoUrl) window.open(videoUrl, '_blank');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
